module.exports = __webpack_public_path__ + "img/GH-kyujin-top-034.9ca4921b.webp";